<template>
    <div class="max-content fee-invoice-page">
            <div class="banner-show">
                <div class="cover">
                    <van-swipe :autoplay="3000" indicator-color="white" :show-indicators="false">
                        <van-swipe-item v-for="(item, key, index) in swiperImg" :key="index">  
                            <img :src="item.image" alt="" />
                        </van-swipe-item>
                    </van-swipe>
                </div>
            </div>
            <div class="bg">
                <div class="btns">
                    <a class="one" href="javascript:void(0)">
                        <img src="./images/fee.png" alt="">
                    </a>
                    <a class="one" href="/vascularnews/meeting/info?meeting_id=674&button_id=4283">
                        <img src="./images/invoice.png" alt="">
                    </a>
                </div>

            </div>
        </div>
</template>
<script>
import {
    MeetingsCarousel,
    MeetingsDetails,
} from "../../../config/interface.js";
import { Col, Row } from "vant"; //预览图片   使用的函数调用

export default {
    components: {
        Col,
        Row
    },
    data() {
        return {
            swiperImg: [],
            images: [],
            show_button_text: 0,
            meeting_name: "",
            views: 0,
            show_views: 0,
            bottom_word_show: 0,
            show_support: 1,
            name: "",
            search_writer_show: false,
            home_bg_color: "", //背景色
            home_bg_img: "", //背景图,
            meeting_id: "674"
        };
    },
    beforeRouteEnter(to, from, next) {
        //  修复iOS版微信HTML5 History兼容性问题
        if (to.path !== location.pathname) {
            location.assign(to.fullPath);
        } else {
            next();
        }
    },
    mounted() {
        // console.log(this.$route)
        // this.meeting_id=this.$route.query.meeting_id;
        this.getMeetingDetails();
        this.getMeetingCarousel();
    },
    methods: {
        //会议轮播
        getMeetingCarousel() {
            const url = MeetingsCarousel;
            let params = {
                meeting_id: this.meeting_id
            };
            const method = "POST";
            fetch(url, params, method).then(res => {
                if (res.code == 0) {
                    let data = res.data;
                    this.swiperImg = data;
                }
            });
        },
        //点击轮播图跳转
        clickSwiperImg(item) {
            window.location.href = item.link;
        },

        //会议详情
        getMeetingDetails(id) {
            const url = MeetingsDetails;
            const method = "POST";
            let params = {
                meeting_id: this.meeting_id
            };
            fetch(url, params, method).then(res => {
                if (res.code == 0) {
                    let data = res.data;
                    document.title = data.name;

                    this.home_bg_img = data.home_bg_img;
                    this.home_bg_color = data.home_bg_color;
                    this.meeting_name = data.name;
                    this.button_rows = data.button_rows;
                    this.show_button_text = data.show_button_text;
                    this.show_views = data.show_views;
                    this.views = data.views;
                    this.bottom_word_show = data.bottom_word_show;
                    this.show_support = data.platform_support_show;
                    this.search_writer_show = data.search_writer_show;

                    //微信浏览器  请求jsdk
                    if (common.is_weixin()) {
                        common.wxShare(data.name, data.title, data.shareimg);
                    }
                }
            });
        }
    }
};
</script>
<style lang="scss" scoped>
.fee-invoice-page {
    overflow: hidden;
    min-height: 100vh;
    background-repeat: no-repeat;
    background-size: 100% 100%;
    background-position: top center;
    height: 100%;
    display: flex;
    flex-direction: column;
    .banner-show {
        width: 100%;

        .cover {
            width: 100%;
            position: relative;

            img {
                width: 100%;
            }
        }
    }

    .bg {
        flex: 1;
        background-image: url(https://cdn.edstatic.com/203012120000/56b7ed339121682bbbc41c8fcbdab129/2026/04/f7077466-9400-406d-9028-5c9f834284bf.png);
        background-size: 100% 100%;
    }

    .btns {
        width: 100%;
        padding: 20px 30px;
        display: flex;
        gap: 30px;

        .one {
            width: 50%;

            img {
                width: 100%;
            }
        }

    }

}



div::webkit-scrollbar {
    display: none;
}
</style>


// WEBPACK FOOTER //
// src/pages/VascularSystem/Meeting674/FeeAndInvoice.vue